import CheckoutMode from "%/dynamic-component-editor/options/checkout-mode";
import {
  PLAN_SHEET_INJECTION_KEY,
  createPlanSheetScope,
} from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

// Shared by both sheet twins: one reactive scope per sheet, provided to every descendant.
export const PlanSheetScopeMixin = {
  provide() {
    return {
      [PLAN_SHEET_INJECTION_KEY]: this.planSheetScope,
    };
  },
  data() {
    return {
      planSheetScope: createPlanSheetScope(() => this.getOptionValue(CheckoutMode)),
    };
  },
};
